export const VISUAL_EXERCISE = 'VisualExercise';
export const EXPORTED_EXERCISES = [VISUAL_EXERCISE];